export const MUTATION_QUERY_PARAMETERS = 'setQueryParameters';
export const MUTATION_REGISTRATION_EMAIL = 'setRegistrationEmail';
export const MUTATION_REGISTRATION_FULLNAME = 'setRegistrationFullName';
export const MUTATION_REGISTRATION_USERID = 'setRegistrationId';
export const MUTATION_REGISTRATION_USERS = 'setRegistrationUsers';
export const QUERY_RETURN_URL_ASPNET = 'returnurl';
